import React, { SvgIcon, SvgIconProps } from '@mui/material'

export default function ArrowForwardIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" />
    </SvgIcon>
  )
}
